export default {
      id: "color_activate_kit-usage",
      viewBox: "0 0 32 39",
      url: __webpack_public_path__ + "sprite.svg#color_activate_kit",
      toString: function () {
        return this.url;
      }
    }